var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38823 12.4741C9.28617 14.3098 10.7742 15.7911 12.6141 16.6807C12.7487 16.7445 12.8976 16.7721 13.0461 16.7609C13.1946 16.7496 13.3377 16.6999 13.4612 16.6166L16.1702 14.8101C16.29 14.7303 16.4278 14.6815 16.5713 14.6683C16.7147 14.6552 16.8591 14.678 16.9914 14.7347L22.0595 16.9067C22.2317 16.9799 22.3754 17.107 22.469 17.2689C22.5627 17.4308 22.6012 17.6188 22.5787 17.8045C22.4185 19.058 21.8069 20.2101 20.8585 21.0451C19.91 21.8801 18.6897 22.3408 17.426 22.3408C13.5231 22.3408 9.78 20.7904 7.0202 18.0306C4.2604 15.2708 2.70996 11.5277 2.70996 7.62475C2.71003 6.36109 3.1707 5.14078 4.00571 4.19231C4.84073 3.24384 5.99283 2.63226 7.2463 2.47207C7.432 2.4496 7.61997 2.48808 7.78189 2.58173C7.94381 2.67537 8.07092 2.81911 8.14405 2.99127L10.318 8.06376C10.3742 8.19496 10.3971 8.33803 10.3847 8.48023C10.3722 8.62244 10.3248 8.75935 10.2466 8.87879L8.44647 11.6294C8.36454 11.7531 8.3161 11.896 8.30589 12.044C8.29569 12.1921 8.32405 12.3402 8.38823 12.4741V12.4741Z",
    stroke: "url(#paint0_linear_5150_96451)",
    strokeWidth: 1.47256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_96451",
    x1: 20.9511,
    y1: 8.75985,
    x2: 2.60881,
    y2: 10.5626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientContactIcon);
export default __webpack_public_path__ + "static/media/gradient_contact_icon.20628aa5f3af5c5182218be08a7f86c5.svg";
export { ForwardRef as ReactComponent };